import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const ONBOARDING_STEP: AuthStepDefinition = {
  id: AuthStepId.ONBOARDING,
  route: AuthStepRoute.Onboarding,
  back: null,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Registration]: {
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
  },
};
